import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const BreakItem = ({
  duration,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        py: 1,
        px: 2,
        borderRadius: 1,
        border: '1px dashed',
        borderColor: 'divider',
        backgroundColor: 'transparent',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderColor: 'primary.light',
          backgroundColor: 'action.hover',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FreeBreakfastIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontStyle: 'italic',
          }}
        >
          {duration} min break
        </Typography>
      </Box>
      {/* Reorder Buttons for Break */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        <Tooltip title="Move up" placement="left">
          <span>
            <IconButton
              size="small"
              onClick={onMoveUp}
              disabled={isFirst}
              sx={{
                padding: '2px',
                '&:disabled': { opacity: 0.3 },
              }}
            >
              <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Move down" placement="left">
          <span>
            <IconButton
              size="small"
              onClick={onMoveDown}
              disabled={isLast}
              sx={{
                padding: '2px',
                '&:disabled': { opacity: 0.3 },
              }}
            >
              <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};

BreakItem.propTypes = {
  duration: PropTypes.number.isRequired,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
};

export default memo(BreakItem);
